"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsRecord_1 = __importDefault(require("../../typeAssertions/valueIsRecord"));
const valueIsArray_1 = __importDefault(require("../../typeAssertions/valueIsArray"));
const valueIsString_1 = __importDefault(require("../../typeAssertions/valueIsString"));
const getNumberFromUnknown_1 = __importDefault(require("../../shared/getNumberFromUnknown"));
const buildCallableGeocoding = (axios) => async ({ functionId, callbacks, executeProcesses, processor, entryVars: { latitude, longitude, }, }) => {
    var _a, _b;
    const geoError = (error) => {
        processor.root.alert('Error', error);
        executeProcesses(functionId, callbacks.error, error);
    };
    try {
        const newLatitude = (0, getNumberFromUnknown_1.default)(latitude);
        const newLongitude = (0, getNumberFromUnknown_1.default)(longitude);
        const googleApiKey = (_b = (_a = processor.root.getBuildOrders()) === null || _a === void 0 ? void 0 : _a.googleApis) === null || _b === void 0 ? void 0 : _b.googleApiKey;
        if (!googleApiKey) {
            geoError('An api key is required!');
            return;
        }
        const { data } = await axios.request({
            url: `https://maps.googleapis.com/maps/api/geocode/json?&latlng=${newLatitude},${newLongitude}&key=${googleApiKey}`,
        });
        const json = data;
        if (!(0, valueIsRecord_1.default)(json)) {
            geoError('Error to retrieve json response');
            return;
        }
        if ((0, valueIsString_1.default)(json.error_message)) {
            geoError(json.error_message);
            return;
        }
        if (!(0, valueIsArray_1.default)(json.results)) {
            geoError('Geocoding results are not in response format');
            return;
        }
        const [details] = json.results;
        if (!(0, valueIsRecord_1.default)(details) || !(0, valueIsRecord_1.default)(details.geometry)) {
            geoError('Details doesn`t have correct format');
            return;
        }
        const { geometry: { location = {} } = {}, formatted_address: formattedAddress, address_components: adressComponents = [], } = details;
        if (!(0, valueIsArray_1.default)(adressComponents)) {
            geoError('Address components is not an array');
            return;
        }
        const vicinityData = adressComponents.find((adressComponent) => {
            const newAdressComponent = adressComponent;
            if (!(0, valueIsRecord_1.default)(newAdressComponent))
                return undefined;
            const { types = [] } = newAdressComponent;
            if (!(0, valueIsArray_1.default)(types))
                return undefined;
            return types.includes('sublocality') || types.includes('sublocality_level_1');
        });
        let vicinity;
        if (vicinityData && (0, valueIsRecord_1.default)(vicinityData)) {
            vicinity = vicinityData.long_name;
        }
        if (!(0, valueIsRecord_1.default)(location)) {
            geoError('Location is not an object');
            return;
        }
        const geoLatitude = (0, getNumberFromUnknown_1.default)(location.lat);
        const geoLongitude = (0, getNumberFromUnknown_1.default)(location.lng);
        executeProcesses(functionId, callbacks.success, {
            formattedAddress,
            location: {
                latitude: geoLatitude,
                longitude: geoLongitude,
            },
            colony: vicinity,
            details,
        });
    }
    catch (err) {
        geoError(`${err}`);
    }
};
exports.default = buildCallableGeocoding;
